import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

/**
 * Duolingo's "Create your profile" shell: a back arrow in the top corner, a
 * centred title, the fields, then the fine print and the log-in line. Shared by
 * the v2 password and email steps so the two halves of the credentials form
 * look like one screen.
 */
export default function DuoSignUpLayout({
  children,
  fineprint,
}: {
  children: ReactNode
  fineprint?: ReactNode
}) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="min-h-dvh bg-white">
      <main className="duo-container flex min-h-dvh flex-col pt-6 pb-8">
        <header className="flex shrink-0 justify-end">
          <button
            aria-label={t('shared.back', { defaultValue: 'Back' })}
            className="text-duo-line-dark hover:text-duo-ink flex h-9 w-9 items-center justify-center transition-colors"
            onClick={() => navigate(-1)}
            type="button"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M19 12H5m0 0 6-6m-6 6 6 6"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </header>

        <div className="flex grow flex-col justify-center gap-6">
          <h1 className="text-duo-ink text-center text-[26px] leading-tight font-extrabold">
            {t('pages.signUp.v2.form.title')}
          </h1>

          {children}

          <div className="space-y-5">
            {fineprint}

            <p className="text-duo-ink text-center text-sm font-extrabold">
              {t('pages.signUp.v2.form.haveAccount')}{' '}
              <Link
                className="text-duo-primary uppercase"
                data-testid="button-login"
                to="/account/sign-in"
              >
                {t('shared.signIn')}
              </Link>
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}
